import { useQuery } from '@tanstack/react-query';
import { fetchSubscriptions } from '../services/subscriptionService';

const activeSubscriptions = (items) =>
  (Array.isArray(items) ? items : [])
    .filter((item) => Number(item?.status) === 1 && item?.slug)
    .sort((a, b) => Number(a.sort_by || 0) - Number(b.sort_by || 0));

export function useSubscriptions(lang = 'EN') {
  return useQuery({
    queryKey: ['subscriptions', lang, 'web'],
    queryFn: async () => {
      const data = await fetchSubscriptions({ lang, platform: 'web' });
      return {
        primarySubscriptions: activeSubscriptions(data.primary_subscriptions),
        addonSubscriptions: activeSubscriptions(data.addon_subscriptions),
      };
    },
    staleTime: 5 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
  });
}
